const CONSENT_STORE_ACCESS_DATA_ON_DEVICE = 1
const CONSENT_SELECT_BASIC_ADVERTISEMENTS = 2
const CONSENT_SELECT_PERSONALISED_ADVERTISEMENTS = 4
const CONSENT_CREATE_PERSONALISED_CONTENT_PROFILE = 5
const CONSENT_SELECT_CUSTOM_CONTENT = 6
const CONSENT_MEASURE_ADVERTISEMENT_PERFORMANCE = 7

export const CONSENTS = {
  GOOGLE_ONE_TAP: [CONSENT_STORE_ACCESS_DATA_ON_DEVICE],
  HOME_POST_CONSENT_LOGIN: [CONSENT_STORE_ACCESS_DATA_ON_DEVICE],
  LAST_DETAILS_VIEWED: [CONSENT_STORE_ACCESS_DATA_ON_DEVICE, CONSENT_SELECT_CUSTOM_CONTENT],
  LAST_ADS_SEARCH: [CONSENT_STORE_ACCESS_DATA_ON_DEVICE, CONSENT_SELECT_CUSTOM_CONTENT],
  SHARE_FAVORITE_MODAL: [CONSENT_STORE_ACCESS_DATA_ON_DEVICE],
  SMARTBANNER_APPS_FLYER: [
    CONSENT_STORE_ACCESS_DATA_ON_DEVICE,
    CONSENT_SELECT_BASIC_ADVERTISEMENTS,
    CONSENT_SELECT_PERSONALISED_ADVERTISEMENTS,
    CONSENT_CREATE_PERSONALISED_CONTENT_PROFILE,
    CONSENT_SELECT_CUSTOM_CONTENT,
    CONSENT_MEASURE_ADVERTISEMENT_PERFORMANCE
  ]
}
